import React from "react";
import { useMemo } from "react";
// import BuildReactTable from "./BuildReactTableTemplate.js";
import LowerManhattanRateTableData from "./LowerManhattanRateTableData.json";
import COLUMNS from "./TableColumns";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
  useFilters
} from "react-table";
import "./tableStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalFilter } from "./GlobalFilter";
// import RatesNavBar from "./NestedNav";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowCircleDown,
  faArrowCircleUp
} from "@fortawesome/free-solid-svg-icons";

library.add(faArrowCircleDown, faArrowCircleUp);


const LowerManhattanBasicTable = () => {
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => LowerManhattanRateTableData, []);
  
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    prepareRow,
    pageOptions,
    gotoPage,
    setPageSize,
    pageCount,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns,
      data
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageSize } = state;
  const { pageIndex } = state;
  return (
    <>
      <div className="container row" style={{ fontSize: "12px" }}>
        {/* <RatesNavBar bottomDist="10px" /> */}
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        {/* <LocationFilter filter={globalFilter} setFilter={setGlobalFilter} /> */}
        <table {...getTableProps}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    {/* <div>
                      {column.canFilter ? column.render("Filter") : null}{" "}
                    </div> */}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faArrowCircleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faArrowCircleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div>
          <span>
            <strong>
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <span>
            | Go to page:{" "}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              style={{ width: "40px" }}
              onChange={(e) => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 0;
                gotoPage(pageNumber);
              }}
            />
          </span>
          <select
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            {[10, 25, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {"<<"}
          </button>
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            Previous
          </button>
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            Next
          </button>
          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>
        </div>
        <br />
        <br />
        <br />
      </div>
    </>
  );
}
export default LowerManhattanBasicTable;
